export default "__VITE_ASSET__BIVhD9Q1__"